import axios from 'axios';
import * as basicConstants from '../constants/basic';

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.withCredentials = true;

// 內部版
export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const STAGING = 'staging';
export const LOCAL = 'local';

// 外部版
export const EXT_PRODUCTION = 'ext-production';
export const EXT_DEVELOPMENT = 'ext-development';
export const EXT_LOCAL = 'ext-local';

export const requestKey = "UluwKUoY5yPnhtFfxPmVKkl64umZx6ACBX7NEdHefdw9R05qSChZfcpH1uGpMbLRzqokLl8RGlszVy57Qtr4HZhiCQwECcDbIqd93R47IxxmhE0s3Rq4NSFgalx3jUrL";

const googleClientIdInt = '157792159170-s7at1ehao18rhdg72fbjiunu561ci4lh.apps.googleusercontent.com';
const googleClientIdExt = '24570910654-dne819t3iv1j3k6bj54gsl6vtqgj77jf.apps.googleusercontent.com';

const facebookAppIdInt = '1428601030784289';
const facebookAppIdExt = '2307534443029931'; //test

const basicConfig = {
  // 內部版
  [PRODUCTION]: {
    apiUrl: 'https://report.haitech.com.tw/HaiWeeklyReportBackend/api',
    folderName: '/HAiReport',
    googleClientId: googleClientIdInt,
    facebookAppId: facebookAppIdInt,
    showVersion: false,
    versionName: '正式版',
    loginType: 'google'
  },
  [STAGING]: {
    apiUrl: 'https://demo.haitech.com.tw/HaiWeeklyReportBackend_test/api',
    folderName: '/haireport_demo',
    googleClientId: googleClientIdInt,
    facebookAppId: facebookAppIdInt,
    showVersion: true,
    versionName: '測試版v4.3.0',
    loginType: 'google'
  },
  [DEVELOPMENT]: {
    apiUrl: 'https://demo.haitech.com.tw/HaiWeeklyReportBackend_dev/api',
    folderName: '/haireport_dev',
    googleClientId: googleClientIdInt,
    facebookAppId: facebookAppIdExt, // 外部版測試用
    showVersion: true,
    versionName: '開發版v4.3.0',
    loginType: 'systemAndGoogle'
  },
  [LOCAL]: {
    apiUrl: '/api',
    googleClientId: googleClientIdInt,
    facebookAppId: facebookAppIdInt,
    folderName: '/',
    showVersion: true,
    versionName: '本機版',
    loginType: 'systemAndGoogle'
  },
  // 外部版
  [EXT_PRODUCTION]: {
    apiUrl: 'https://report.haitech.com.tw/HaiWeeklyReportBackend_jp/api',
    folderName: '',
    googleClientId: googleClientIdExt,
    facebookAppId: facebookAppIdExt,
    showVersion: false,
    versionName: process.env.REACT_APP_VERSION,
    loginType: 'systemAndGoogle' // test
  },
  [EXT_DEVELOPMENT]: {
    // apiUrl: 'https://report.haitech.com.tw/HaiWeeklyReportBackend_dev/api',
    apiUrl: 'https://external-report-dev.haitechservice.com/HaiWeeklyReportBackend_dev/api',
    folderName: '',
    googleClientId: googleClientIdExt,
    facebookAppId: facebookAppIdExt,  // 外部版測試用
    showVersion: true,
    versionName: process.env.REACT_APP_VERSION,
    loginType: 'systemAndGoogle' // test
  },
  [EXT_LOCAL]: {
    apiUrl: '/api',
    googleClientId: googleClientIdExt,
    facebookAppId: facebookAppIdExt,
    folderName: '',
    showVersion: true,
    versionName: 'jp本機版',
    loginType: 'systemAndGoogle'
  }
}

// export const currentStage = PRODUCTION;
// export const currentStage = STAGING;
// export const currentStage = DEVELOPMENT;
// export const currentStage = LOCAL;

// export const currentStage = EXT_PRODUCTION;
export const currentStage = EXT_DEVELOPMENT;
// export const currentStage = EXT_LOCAL;

export const baseUrl = basicConfig[currentStage];

export const apiRequest = axios.create({
  baseURL: baseUrl.apiUrl,
  // headers: {
  //   'Content-Type': 'application/json'
  // }
})

export const apiExternalRequest = axios.create({
  baseURL: basicConfig[PRODUCTION].apiUrl,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
})

export const apiUserLogin = data => apiRequest.post('/auth/login', data);
export const apiUserGoogleLogin = data => apiRequest.post('/auth/googleLogin', data);
export const apiUserCheckAdmin = data => apiRequest.get('/auth/isAdmin', data);
export const apiUserCheckStatus = data => apiRequest.get('/auth/loginStatus', data);
export const apiUserLogout = data => apiRequest.post('/auth/logout', data);
export const apiGetOwnedAdAccount = (data, cancelData) => apiRequest.get('/auth/getOwnedAdAccount', data, cancelData);

export const apiGetUsers = (data, cancelData) => apiRequest.get('/getUsers', data, cancelData);
export const apiTransReports = (data, cancelData) => apiRequest.get('/transReports', data, cancelData);

//-----------------------------------------------Facebook-----------------------------------------------

// ad account
export const apiGetFacebookAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/facebookLogin', null, { params: data });
export const apiBindFacebookAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/facebookLogin/authorize', null, { params: data });

// report 
export const apiReportList = (data, cancelData) => apiRequest.get('/weeklyReport', data, cancelData);
export const apiCreateReport = (data, cancelData) => apiRequest.post('/weeklyReport', data, cancelData);
export const apiUpdateReport = (data, config) => apiRequest.put('/weeklyReport', data, { params: config });
export const apiDeleteReport = data => apiRequest.delete(`/weeklyReport?weeklyReportId=${data}`);

// fields
export const apiColumnDefinition = data => apiRequest.get('/columnDefinition', data);
export const apiCustomEvents = data => apiRequest.get('/getCustom', data);

// send
export const apiTestSend = (data, cancelData) => apiRequest.post('/weeklyReportTestSend', null, { params: data });
export const apiSendAllEmails = (data, cancelData) => apiRequest.post('/weeklyReportReSend', null, { params: data });

// download
export const apiTestDownload = (data, cancelData) => apiRequest.post('/weeklyReportTestDownload', null, data);
export const apiDownloadCustomReport = (data, cancelData) => apiRequest.post('/custom_report', null, data);
export const apiDownloadExternalReport = (data, config) => apiRequest.post('/externalService/weeklyReport/excel_fb', data, config);

// campaign
export const apiGetCampaign = data => apiRequest.get('/getCampaign', data);


//-----------------------------------------------Google-----------------------------------------------

// ad account
export const apiGetGoogleAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/googleLogin', null, { params: data });
export const apiBindGoogleAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/googleLogin/authorize', null, { params: data });

// report 
export const apiGoogleReportList = (data, cancelData) => apiRequest.get('/google/weeklyReport', data, cancelData);
export const apiGoogleCreateReport = (data, cancelData) => apiRequest.post('/google/weeklyReport', data, cancelData);
export const apiGoogleUpdateReport = (data, config) => apiRequest.put('/google/weeklyReport', data, { params: config });
export const apiGoogleDeleteReport = data => apiRequest.delete(`/google/weeklyReport?weeklyReportId=${data}`);

// fields
// export const apiGoogleDefinition = data => apiRequest.get('/googleDefinition', data);
export const apiGoogleCustomFields = data => apiRequest.get('/google/custom_fields', data);

// send
export const apiGoogleTestSend = (data, cancelData) => apiRequest.post('/google/weeklyReportTestSend', null, { params: data });
export const apiGoogleSendAllEmails = (data, cancelData) => apiRequest.post('/google/weeklyReportReSend', null, { params: data });

// download
export const apiGoogleTestDownload = (data, cancelData) => apiRequest.post('/google/weeklyReportTestDownload', null, data);
export const apiGoogleDownloadReport = (data, cancelData) => apiRequest.post('/google/custom_report', null, data);
export const apiGoogleDownloadExternalReport = (data, config) => apiRequest.post('/externalService/weeklyReport/excel', data, config);

// campaign
export const apiGoogleGetCampaign = data => apiRequest.get('/google/getCampaign', data);

//-----------------------------------------------Line-----------------------------------------------

// ad account
export const apiGetLineAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/lineLogin', null, { params: data });
export const apiBindLineAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/lineLogin/authorize', data);

// report 
export const apiLineReportList = (data, cancelData) => apiRequest.get('/line/weeklyReport', data, cancelData);
export const apiLineCreateReport = (data, cancelData) => apiRequest.post('/line/weeklyReport', data, cancelData);
export const apiLineUpdateReport = (data, config) => apiRequest.put('/line/weeklyReport', data, { params: config });
export const apiLineDeleteReport = data => apiRequest.delete(`/line/weeklyReport?weeklyReportId=${data}`);

// fields
export const apiLineDefinition = data => apiRequest.get('/lineDefinition', data);
export const apiLineCustomFields = data => apiRequest.get('/line/custom_fields', data);

// send
export const apiLineTestSend = (data, cancelData) => apiRequest.post('/line/weeklyReportTestSend', null, { params: data });
export const apiLineSendAllEmails = (data, cancelData) => apiRequest.post('/line/weeklyReportReSend', null, { params: data });

// download
export const apiLineTestDownload = (data, cancelData) => apiRequest.post('/line/weeklyReportTestDownload', null, data);
export const apiLineDownloadReport = (data, cancelData) => apiRequest.post('/line/custom_report', null, data);
export const apiLineDownloadExternalReport = (data, config) => apiRequest.post('/externalService/weeklyReport/excel_line', data, config);

// target
export const apiLineGetTarget = data => apiRequest.get('/line/getTarget', data);

// campaign
export const apilineGetCampaign = data => apiRequest.get('/line/getCampaign', data);

//-----------------------------------------------Taboola-----------------------------------------------

// ad account
export const apiGetTaboolaAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/taboolaLogin', null, { params: data });
export const apiBindTaboolaAdAccounts = data => apiRequest.post('/auth/authorizedAdAccount/taboolaLogin/authorize', data);

// report 
export const apiTaboolaReportList = (data, cancelData) => apiRequest.get('/taboola/weeklyReport', data, cancelData);
export const apiTaboolaCreateReport = (data, cancelData) => apiRequest.post('/taboola/weeklyReport', data, cancelData);
export const apiTaboolaUpdateReport = (data, config) => apiRequest.put('/taboola/weeklyReport', data, { params: config });
export const apiTaboolaDeleteReport = data => apiRequest.delete(`/taboola/weeklyReport?weeklyReportId=${data}`);

// fields
export const apiTaboolaDefinition = data => apiRequest.get('/taboolaDefinition', data);
export const apiTaboolaCustomFields = data => apiRequest.get('/taboola/custom_fields', data);

// send
export const apiTaboolaTestSend = (data, cancelData) => apiRequest.post('/taboola/weeklyReportTestSend', null, { params: data });
export const apiTaboolaSendAllEmails = (data, cancelData) => apiRequest.post('/taboola/weeklyReportReSend', null, { params: data });

// download
export const apiTaboolaTestDownload = (data, cancelData) => apiRequest.post('/taboola/weeklyReportTestDownload', null, data);
export const apiTaboolaDownloadReport = (data, cancelData) => apiRequest.post('/taboola/custom_report', null, data);
export const apiTaboolaDownloadExternalReport = (data, config) => apiRequest.post('/externalService/weeklyReport/excel_taboola', data, config);

// campaign
export const apiTaboolaGetCampaign = data => apiRequest.get('/taboola/getCampaign', data);

export const removeStorageRecord = () => {
  sessionStorage.removeItem(basicConstants.SESSION_CREATE_TIME);
}